module.exports = __webpack_public_path__ + "img/Group_26974.f4288ed9.svg";